const state = {
  search_error: null,
  search: [],
};

const mutations = {
  search(state) {
    state.search_error = null;
  },
  searchFailed(state, payload) {
    const err = payload.error.response.data.errors;
    state.search_error = Object.values(err)[0][0];
  },
  searchSuccess(state, payload) {
    state.search_error = null;
    state.search = payload;
  },
};

const actions = {
  search: ({ commit }) => commit('search'),
};

const getters = {
  searchError: (state) => state.search_error,
  search: (state) => state.search,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
